import { render } from "./ImgItem.vue?vue&type=template&id=6b2bb427&scoped=true&ts=true"
import script from "./ImgItem.vue?vue&type=script&lang=ts"
export * from "./ImgItem.vue?vue&type=script&lang=ts"

import "./ImgItem.vue?vue&type=style&index=0&id=6b2bb427&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2bb427"]])

export default __exports__